<template>
  <div class="gmap" id="gmap"></div>
</template>

<script>
import { PrepareTooltipData } from '../../model/prepareTooltipData'

export default {
  name:  'MapBlock',
  props: ['item'],

  data () {
    return {
      points:          [],
      tooltip:         null,
      tooltipRenderer: new PrepareTooltipData()
    }
  },

  mounted () {
    setTimeout(() => {
      let options = {
            el:             '#gmap',
            lat:            49.825093,
            lng:            15.604959,
            zoom:           8,
            zoomControl:    true,
            zoomControlOpt: {
              style:    'SMALL',
              position: 'TOP_LEFT'
            }
          },
          map     = new GMaps(options)

      this._connectPoints(map)

      if (!this.item.hasOwnProperty('FieldValues')) {
        return
      }

      if (this.item.FieldValues && this.item.FieldValues.length > 1 && this._pointsHasVariousCoordinates()) {

        //vycentruje mapu ke vsem markerum
        map.fitZoom()

        setTimeout(() => {
          map.setZoom(map.getZoom() - 1)
        }, 100)

      }
      else {
        let item        = this.item.FieldValues[0],
            coordinates = JSON.parse(item.coordinates)

        setTimeout(() => {
          map.setCenter(coordinates[1], coordinates[[0]])
          map.setZoom(10)
        }, 100)
      }
    }, 200)

  },

  methods: {

    /**
     *
     * @param map
     * @private
     */
    _connectPoints (map) {
      if (!this.item.hasOwnProperty('FieldValues')) {
        return
      }

      for (let i = 0; i < this.item.FieldValues.length; i++) {
        const innerItem   = this.item.FieldValues[i],
              coordinates = JSON.parse(innerItem.coordinates),
              lng         = coordinates[0],
              lat         = coordinates[1],
              title       = innerItem.Title,
              description = innerItem.description

        let pinImage = new google.maps.Marker({
          position: { lat: lat, lng: lng },
          map:      map.map,
          icon:     this._createPin(innerItem.MapPointColor)
        })

        if (innerItem.MapPointAvatar) {
          const avatarData = JSON.parse(innerItem.MapPointAvatar)
          let avatar       = new google.maps.Marker({
            position: pinImage.getPosition(),
            map:      map.map,
            icon:     {
              url:        avatarData.Value,
              scaledSize: new google.maps.Size(35, 35),
              anchor:     new google.maps.Point(-18, 75)
            }
          })
        }

        pinImage.addListener('mouseover', (e) => {
          if (!innerItem.tEntityCode || !innerItem.idtTask) {
            return
          }

          this.tooltipRenderer.prepare(
            this.findMouseeventTarget(e),
            innerItem.tEntityCode,
            innerItem.idtTask,
            (tooltip) => {
              if (this.tooltip) {
                this.tooltip.hide()
              }
              tooltip.show()
              this.tooltip = tooltip
            },
            (error) => this.handleApiError(error),
            this.$translate
          )
        })

        pinImage.addListener('click', (e) => {
          if (this.tooltip) {
            this.tooltip.hide()
          }

          if (!innerItem.tEntityCode || !innerItem.idtTask || innerItem.idtTask === 'null') {
            return
          }

          this.$router.push({
            name:   'PageDynamicEditor',
            params: { page: innerItem.tEntityCode, idStructure: '0', id: innerItem.idtTask, redir: 'grid' }
          })
        })

        map.addMarker(pinImage)
      }
    },

    _createPin (color) {
      return {
        path:         'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
        fillColor:    color,
        fillOpacity:  1,
        strokeColor:  '#000',
        strokeWeight: 2,
        scale:        1.2
      }
    },

    /**
     *
     * @private
     */
    _pointsHasVariousCoordinates () {
      if (!this.item.hasOwnProperty('FieldValues') || this.item.FieldValues.length < 2) {
        return false
      }

      for (let i = 0; i < this.item.FieldValues.length; i++) {
        let innerItem   = this.item.FieldValues[i],
            coordinates = JSON.parse(innerItem.coordinates),
            lng         = coordinates[0],
            lat         = coordinates[1]

        if (!this.item.FieldValues[i + 1]) {
          return false
        }

        let innerItem2   = this.item.FieldValues[i + 1],
            coordinates2 = JSON.parse(innerItem2.coordinates),
            lng2         = coordinates2[0],
            lat2         = coordinates2[1]

        if (lat !== lat2 || lng !== lng2) {
          return true
        }

      }
    },

    /**
     *
     * @param e
     * @returns {*}
     */
    findMouseeventTarget (e) {
      for (const propertyName in e) {
        if (e.hasOwnProperty(propertyName)
          && typeof e[propertyName] === 'object'
          && e[propertyName].target) {
          return e[propertyName].target
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
